import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";

const setCaptchaSettingsCommandZodObject = z.object({
    _id: idZodSchema,
    _type: z.literal("SET_CAPTCHA_SETTINGS_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    countryCodesRequiringCaptcha: z.array(z.number()),
    numberSeriesRequiringCaptcha: z.array(z.string()),
});
type SetCaptchaSettingsCommand = z.infer<
    typeof setCaptchaSettingsCommandZodObject
>;
const setCaptchaSettingsCommandZodScheme =
    setCaptchaSettingsCommandZodObject as z.ZodSchema<SetCaptchaSettingsCommand>;

type FactoryParams = Except<
    SetCaptchaSettingsCommand,
    "_id" | "_type" | "_createdAt"
>;
const setCaptchaSettingsCommandFactory = (params: FactoryParams) => {
    const command: SetCaptchaSettingsCommand = {
        ...params,
        _id: generateId({ prefix: "set_captcha_settings_command__" }),
        _type: "SET_CAPTCHA_SETTINGS_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return command;
};

export {
    setCaptchaSettingsCommandFactory,
    setCaptchaSettingsCommandZodObject,
    setCaptchaSettingsCommandZodScheme,
};
export type {
    SetCaptchaSettingsCommand,
    FactoryParams as SetCaptchaSettingsCommandFactoryParams,
};
